import {
	BaggageType,
	GdsServiceVipSubType,
	NASProductCategory,
	NASProductType,
	OrderAdditionalServiceGdsServiceServiceType
} from '@websky/graphql';

export enum SpecialServiceType {
	Insurance = 'Insurance',
	Aeroexpress = 'Aeroexpress'
}

export type CombinedSelectedServiceType =
	| OrderAdditionalServiceGdsServiceServiceType
	| NASProductCategory
	| SpecialServiceType;

export type CombinedSelectedServiceSubType = BaggageType | GdsServiceVipSubType | NASProductType;

export type SelectedService = {
	rfisc?: string;
	type: CombinedSelectedServiceType;
	subType?: CombinedSelectedServiceSubType;
	insuranceCode?: string;
};
